import { cn } from "@/utils/classnames";

export function TransactionStatusBadge({ status }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset text-red-700 ring-red-600/20 bg-red-50",
        {
          "text-yellow-700 ring-yellow-600/20 bg-yellow-50":
            status === "pending",
          "text-green-700 ring-green-600/20 bg-green-50":
            status === "completed",
        }
      )}
    >
      <span className="capitalize">{status}</span>
    </span>
  );
}
